<template>
    <div class="clearfix" style="position: relative">
        <Form
            ref="myForm"
            class="padding-20"
            :model="formData"
            :labelWidth="120"
        >
            <FormItem
                :label="
                    $t('boss.purchase.latest_estimated_delivery_date', {
                        defaultValue: '最新预计交货日期',
                    })
                "
                prop="expectedDeliveryDate"
                :rules="required"
            >
                <DatePicker
                    class="width-80per"
                    v-model="formData.expectedDeliveryDate"
                    format="yyyy-MM-dd"
                    type="date"
                ></DatePicker>
            </FormItem>
            <FormItem
                :label="
                    $t('boss.purchase.expected_listing_date_now', {
                        defaultValue: '现预计上架日期',
                    })
                "
            >
                <div class="font-bold">{{ expectedFinishDate }}</div>
            </FormItem>
            <FormItem
                :label="
                    $t('boss.purchase.new_estimated_launch_date', {
                        defaultValue: '新预计上架日期',
                    })
                "
            >
                <DatePicker
                    class="width-80per"
                    v-model="formData.expectedFinishDate"
                    format="yyyy-MM-dd"
                    type="date"
                ></DatePicker>
                <span
                    class="margin-left-15"
                    style="font-size: 16px; cursor: pointer"
                >
                    <Tooltip style="">
                        <Icon type="ios-information-circle" />
                        <div
                            slot="content"
                            style="width: 200px; white-space: normal"
                        >
                            {{
                                $t("boss.purchase.leave_it_blank_a", {
                                    defaultValue:
                                        "交货日期如有变更，预计上架日期可能也需要变更；若不需要变更，则留空",
                                })
                            }}
                        </div>
                    </Tooltip>
                </span>
            </FormItem>
            <FormItem
                :label="
                    $t('boss.purchase.notes', {
                        defaultValue: '备注',
                    })
                "
            >
                <Input
                    class="width-80per"
                    v-model="formData.remark"
                    type="textarea"
                />
            </FormItem>
        </Form>
        <div class="button-container pull-right" style="margin: 10px 0">
            <Button class="margin-right-15" type="primary" @click="submit">
                {{
                    $t("boss.purchase.sure", {
                        defaultValue: "确定",
                    })
                }}</Button
            >
            <Button @click="$emit('on-close')">{{
                $t("boss.purchase.sure", {
                    defaultValue: "返回",
                })
            }}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpUpdateExpectDeliveryDate,
    HttpGetExpectedDate,
} from "@/service/purchase/purchase";
export default {
    props: ["id", "expectedFinishDate"],
    data() {
        return {
            loading: false,
            formData: {},
        };
    },
    watch: {
        "formData.expectedDeliveryDate": {
            handler(val) {
                if (!val) return;
                this.getDate(val);
            },
        },
    },
    computed: {
        required() {
            return [
                {
                    required: true,
                    message: this.$t("boss.purchase.item_cannot_empty", {
                        defaultValue: "此项不能为空",
                    }),
                },
            ];
        },
    },
    methods: {
        async getDate(date) {
            let newDate = this.handleDateFormat(date, "yyyy-mm-dd");
            await HttpGetExpectedDate({
                poOrderId: this.id,
                deliverDate: newDate,
            }).then(
                (res) => {
                    this.$set(this.formData, "expectedFinishDate", res.message);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async submit() {
            let flag = true;
            await this.$refs.myForm.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            this.loading = true;
            await HttpUpdateExpectDeliveryDate({
                id: this.id,
                expectedDeliveryDate: this.handleDateFormat(
                    this.formData.expectedDeliveryDate,
                    "yyyy-mm-dd"
                ),
                expectedFinishDate: this.formData.expectedFinishDate
                    ? this.handleDateFormat(
                          this.formData.expectedFinishDate,
                          "yyyy-mm-dd"
                      )
                    : null,
                remark: this.formData.remark,
            })
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$emit("on-update");
                        this.$emit("on-close");
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style></style>
